/**
 * Application configuration
 * Uses environment variables with fallback defaults
 */

const config = {
  // Backend API URL
  apiUrl: process.env.REACT_APP_API_URL || "http://localhost:8000",

  // EmailJS Configuration
  emailjs: {
    serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID,
    templateId: process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
    publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
  },
};

export default config;
